<template>
  <div class="wrapper"><privacy-policy /></div>
</template>
<style scoped>
  .wrapper {
    width: 100vw;
  }
</style>

<script>
import 'styles/main.scss'
import privacyPolicy from 'brave-company/components/privacy-policy'
export default {
  name: 'terms-of-service',
  data () {
    return {

    }
  },
  components: {privacyPolicy}
}
</script>

